import React from 'react';
import { Trans } from '@gamiphy/react-i18n';
import {
  Card, CardContent, Grid,
} from '@mui/material';
import { formatCash } from '@gamiphy/utils/currency';
import { useOnCopy } from '@gamiphy/utils/react';
import { DiscountDto } from '@coretava/api/ecommerce-service';
import DiscountCodeButton from './DiscountCodeButton';

type Props = {
  discount: DiscountDto;
};

const DiscountCodeCard: React.FC<Props> = ({
  discount,
}) => {
  const {
    copied,
    onCopy,
  } = useOnCopy(discount.code);

  return (
    <Card
      sx={(theme) => ({
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.text.secondary,
      })}
    >
      <CardContent>
        <Grid container alignItems="center" spacing={1}>
          <Grid
            sx={{ fontSize: '1.8rem', fontWeight: 'bold' }}
            size={6}
          >
            {formatCash(discount.value)}
          </Grid>
          {discount.expiresAt && (
            <Grid size={6}>
              <Trans
                i18nKey="discountCode.expiresAt"
                defaults="Expires at {{date, datetime}}"
                values={{
                  date: new Date(discount.expiresAt),
                }}
              />
            </Grid>
          )}
          <Grid
            size={12}
            sx={(theme) => ({
              p: theme.spacing(1),
              textAlign: 'center',
            })}
          >
            <DiscountCodeButton
              onCopy={onCopy}
              copied={copied}
              discountCode={discount.code}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default DiscountCodeCard;
